import { v4 as uuid } from 'uuid';

export class QueryRequest<QueryModel> {
  requestId: string = uuid();

  sessionId: string = uuid();

  query: QueryModel;
}
